import { ApiRoute } from 'config';
import { UpcomingMenusContext, ContextValue } from 'contexts/UpcomingMenus';
import createUseContextHook from './createUseContextHook';

const useUpcomingMenus = createUseContextHook<ContextValue>(
// @ts-expect-error TODO: fix null safety
  UpcomingMenusContext,
  ApiRoute.UPCOMING_MENUS,
);

export default useUpcomingMenus;
